//FileAttachmentControlView.js

import { View } from 'backbone';
import eventBus         from 'EventBus.js';
import constants                from 'Constants.js';
import BaseControlView from 'BaseControlView.js';
import template from 'advanced-inputs/control_file_attachment.ejs';

//=====================================================================
//
// An instance of this view represents a file attachment control
//
// Maty Rocha, February 17, 2016
//
//=====================================================================
class FileAttachmentControlView extends BaseControlView  {

    initialize( opts ) {

        super.initialize( opts );

        this.template = template;

        this.tagName = 'div';
        this.family = constants.CONTROL_ADVANCED_INPUTS;
        this.subfamily = constants.CONTROL_ATTACHMENTS;

        this.model.set('selectFields', [
            {id: this.model.get('id'), text: 'Attachment Id'}, 
            {id: this.model.get('id') + '$v', text: 'Attachment Name'},
            {id: this.model.get('id') + '$d', text: 'Attachment File'}
        ], {silent:true});

        this.events = {
        };

        this.listenTo(this.model, 'change', this.render);
        this.listenTo( eventBus, 'InputThemeChange', this.themeChangeRender);
        this.listenTo( eventBus, 'ButtonThemeChange', this.themeChangeRender);
        this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);

        return this;
    }

    // Neighbor aligner uses this polymorphic property, looking for
    // value 'BaseStaticTextControl'
    get kind() {
        return 'FileAttachmentControlView';
    }


}

export default FileAttachmentControlView;
